import React from 'react';
import DisModal from './design-system/DisModal';
import DisButton from './design-system/DisButton';

const PlanLimitModal = ({ isOpen, onClose, onUpgrade, limitType = 'children' }) => {
  const limitMessages = {
    children: {
      icon: '👶',
      title: 'Limite de profils atteinte',
      description: 'Votre plan actuel est limité à un seul profil enfant.',
      benefit: 'Pour ajouter plusieurs enfants et profiter pleinement de Dis Maman!, passez au plan Famille !',
      features: [
        '✨ Profils enfants illimités',
        '🎯 Questions illimitées', 
        '📚 Historique complet',
        '🎨 Réponses personnalisées pour chaque enfant'
      ]
    }
  };

  const content = limitMessages[limitType];

  return (
    <DisModal isOpen={isOpen} onClose={onClose} title="">
      <div className="text-center p-6">
        {/* Icône principale */}
        <div className="text-6xl mb-4">{content.icon}</div>
        
        {/* Titre */}
        <h2 className="text-2xl font-bold text-gray-900 mb-3">
          {content.title}
        </h2>
        
        {/* Description */}
        <p className="text-gray-600 mb-4">
          {content.description}
        </p>
        
        {/* Avantage du plan Family */}
        <div className="bg-gradient-to-r from-teal-50 to-cyan-50 border border-teal-200 rounded-lg p-4 mb-6">
          <p className="text-teal-800 font-medium mb-3">
            {content.benefit}
          </p>
          
          {/* Fonctionnalités du plan Family */}
          <div className="space-y-2">
            {content.features.map((feature, index) => (
              <div key={index} className="text-sm text-teal-700 text-left">
                {feature}
              </div>
            ))}
          </div>
        </div>

        {/* Boutons d'action */}
        <div className="space-y-3">
          <DisButton
            onClick={onUpgrade}
            className="w-full bg-gradient-to-r from-blue-500 to-teal-500 hover:from-blue-600 hover:to-teal-600 text-white py-3 font-bold shadow-lg transform hover:scale-105 transition-all"
          >
            🚀 Passer au Plan Famille
          </DisButton>
          
          <DisButton
            variant="ghost"
            onClick={onClose}
            className="w-full text-gray-600 hover:text-gray-800"
          >
            Plus tard
          </DisButton>
        </div>
      </div>
    </DisModal>
  );
};

export default PlanLimitModal;